import { Link } from 'react-router-dom';
import { Calendar, TrendingUp, ExternalLink } from 'lucide-react';
import { ShareButtons } from './ShareButtons';

const PRIZEPICKS_URL = 'https://prizepicks.onelink.me/FjtC/d9ee5h8t';

// Fix double-encoded UTF-8 characters (e.g., â€" should be —)
const fixEncoding = (text) => {
  if (!text) return '';
  return text
    // Em-dash variations
    .replace(/â€"/g, '—')
    .replace(/â€"/g, '–')
    .replace(/â€"(?=[0-9])/g, '—')  // em-dash before numbers
    // Quote variations
    .replace(/â€™/g, "'")
    .replace(/â€˜/g, "'")
    .replace(/â€œ/g, '"')
    .replace(/â€/g, '"')
    .replace(/â€¦/g, '…')
    // Space and accent variations
    .replace(/Â /g, ' ')
    .replace(/Ã©/g, 'é')
    .replace(/Ã¨/g, 'è')
    .replace(/Ã /g, 'à')
    // Catch any remaining â€ patterns (generic cleanup)
    .replace(/â€\u009d/g, '"')
    .replace(/â€\u0093/g, '"')
    .replace(/â€/g, '—');  // Final fallback for em-dash
};

export const PickCard = ({ pick, featured = false }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const getConfidenceColor = (level) => {
    if (level >= 8) return 'text-accent';
    if (level >= 5) return 'text-secondary';
    return 'text-muted-foreground';
  };

  return (
    <Link
      to={`/pick/${pick.id}`}
      className={`bg-card border border-border hover:border-primary/50 transition-all duration-300 group block ${
        featured ? 'md:col-span-2 lg:col-span-2' : ''
      }`}
      data-testid={`pick-card-${pick.id}`}
    >
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <span className="font-mono text-xs uppercase tracking-widest text-primary" data-testid="pick-sport">{pick.sport}</span>
          <div className="flex items-center gap-2 font-mono text-xs text-muted-foreground" data-testid="pick-date">
            <Calendar size={12} />
            {formatDate(pick.pick_date)}
          </div>
        </div>
        <h3 className={`font-heading font-bold mb-3 group-hover:text-primary transition-colors ${
          featured ? 'text-2xl' : 'text-xl'
        }`} data-testid="pick-title">
          {pick.player_name} - {pick.prop_type}
        </h3>
        <div className="space-y-2 mb-4">
          <p className="text-muted-foreground text-sm" data-testid="pick-line"><span className="font-mono font-bold">LINE:</span> {pick.line}</p>
          <p className="text-foreground font-bold text-sm" data-testid="pick-prediction"><span className="font-mono">PICK:</span> {pick.pick}</p>
        </div>
        <p className="text-muted-foreground text-sm leading-relaxed mb-4 line-clamp-2" data-testid="pick-reasoning">{fixEncoding(pick.reasoning)}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <TrendingUp size={16} className={getConfidenceColor(pick.confidence_level)} />
            <span className={`font-mono text-sm font-bold ${getConfidenceColor(pick.confidence_level)}`} data-testid="pick-confidence">
              CONFIDENCE: {pick.confidence_level}/10
            </span>
          </div>
          <span className="font-heading text-xs uppercase tracking-widest text-primary group-hover:underline">View Analysis →</span>
        </div>
        <div className="mt-4 pt-4 border-t border-border flex items-center justify-between gap-3">
          <ShareButtons pick={pick} compact />
          <a
            href={PRIZEPICKS_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="flex items-center gap-1.5 bg-secondary hover:bg-secondary/80 text-white text-xs font-bold px-3 py-2 rounded transition-all hover:scale-105"
            data-testid={`bet-prizepicks-${pick.id}`}
          >
            <ExternalLink size={12} />
            Bet on PrizePicks
          </a>
        </div>
      </div>
    </Link>
  );
};